module.exports = __webpack_public_path__ + "img/pic_zhineng.83aad4a7.png";